// extracted by mini-css-extract-plugin
module.exports = {"PriceBox":"Prices_PriceBox__2uiG3","Price":"Prices_Price__3fubh","OldPrice":"Prices_OldPrice__37Yr7","NewPrice":"Prices_NewPrice__3x4TK"};